import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { AttachmentCard, getAttachmentSizeReserve } from 'entities/Attachment'
import { MessageCardType, type MessageProps } from 'widgets/MessageCard/ui/types'
import { ConversationMessageCardItem } from 'widgets/MessageCard/ui/ConversationMessageCardItem/ConversationMessageCardItem'
import { DateContent } from 'widgets/MessageCard/ui/DateContent/DateContent'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type IVideoContentProps = MessageProps & {
  reserveMediaSize?: boolean
}

export const VideoContent = observer((props: IVideoContentProps) => {
  const { videos } = props.message
  const presentationStore = usePresentationModeContext()

  const onOpenPresentation = (index: number) => () => {
    presentationStore.setAttachments(videos, index, true)
  }

  if (!videos.length) {
    return <></>
  }

  return (
    <>
      {videos.map((attachment, index) => {
        const sizeReserve = props.reserveMediaSize
          ? getAttachmentSizeReserve(attachment)
          : undefined

        return (
          <ConversationMessageCardItem
            key={attachment.id}
            message={props.message}
            type={MessageCardType.Video}
          >
            <div className={classNames(styles.wrap)} style={sizeReserve}>
              <AttachmentCard
                attachment={attachment}
                medium
                onCardClick={onOpenPresentation(index)}
                onLoad={props.onLoad}
              />
            </div>
            <DateContent {...props} />
          </ConversationMessageCardItem>
        )
      })}
    </>
  )
})
